// extracted by mini-css-extract-plugin
export default {"discountsContainer":"Discounts_discountsContainer__G9IDO"};